import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { LayoutModule } from '../../../../layout/modules';
import { usePqrReceivedThroughDetail } from './hook';
import { PqrReceivedThroughData } from './data';
import { PqrReceivedThroughParamsHistorical } from '../historical';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    PQR_RECEIVED_THROUGH_NEW,
    PQR_RECEIVED_THROUGH,
    PQR_RECEIVED_THROUGH_EDIT,
    PQR_RECEIVED_THROUGH_DETAIL,
} from '../../../../../routes/paths';
import { PqrReceivedThroughRegisterHistory } from './registerHistory';

export const PqrReceivedThroughDetail = () => {
    const {
        pqrReceivedThrough,
        pqrReceivedThroughHistorical,
        showHistorical,
        setShowHistorical,
    } = usePqrReceivedThroughDetail();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle medio PQR"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={pqrReceivedThrough?.id || ''}
                        buttonCreate={{
                            show: !isOnlyViewProfile(type),
                            route: PQR_RECEIVED_THROUGH_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PQR_RECEIVED_THROUGH,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: PQR_RECEIVED_THROUGH_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: PQR_RECEIVED_THROUGH_DETAIL,
                        }}
                        buttonLog={{
                            show: Boolean(pqrReceivedThrough?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <PqrReceivedThroughParamsHistorical
                            historical={pqrReceivedThroughHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title=""
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <PqrReceivedThroughData data={pqrReceivedThrough} />
                </LayoutModule>
            </LayoutModule>
            <PqrReceivedThroughRegisterHistory
                pqrReceivedThrough={pqrReceivedThrough}
            />
        </>
    );
};
